import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import type { Modules } from '~/types/equipment';

import { useCrudCreate, useCrudUpdate } from '~/shared/hooks/useCrudMutations';
import useCrudQuery from '~/shared/hooks/useCrudQuery';
import { resolveEquipmentConflictMessage } from '~/utils/equipmentErrors';

import modulesService from '../services/modulesService';

export function useCreateModule() {
  const handleError = (error: any) => {
    const conflictMessage = resolveEquipmentConflictMessage(error);
    if (conflictMessage) return conflictMessage;
    return error?.response?.data?.message || 'Erro ao cadastrar módulo';
  };

  return useCrudCreate('modules', 'Módulo', modulesService.create.bind(modulesService), handleError);
}

export function useModuleById(id: Ref<null | number>) {
  return useQuery({
    enabled: () => !!id.value,
    queryFn: () => {
      if (!id.value) throw new Error('ID é obrigatório');
      return modulesService.getById(id.value);
    },
    queryKey: ['module', id],
  });
}

export function useModules(params: Ref<Modules.GetModulesRequest>) {
  return useCrudQuery(params, 'modules', modulesService.list.bind(modulesService));
}

export function useUpdateModule() {
  const handleError = (error: any) => {
    if (error?.response?.status === 404) {
      return 'Módulo não encontrado';
    }
    const conflictMessage = resolveEquipmentConflictMessage(error);
    if (conflictMessage) return conflictMessage;
    return error?.response?.data?.message || 'Erro ao atualizar módulo';
  };

  return useCrudUpdate('modules', 'Módulo', modulesService.update.bind(modulesService), handleError);
}
